module.exports = __webpack_public_path__ + "static/img/step4.c71abe53.jpg";